export default __webpack_public_path__ + "static/media/Pillars_of_Gold_LE.598177ae.jpg";